import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * Legacy standalone favorites page. Collections → Favorites is the canonical
 * page for the same list (and the one the nav links to), so old deep links
 * redirect there — same pattern as saved-searches.tsx.
 */
export const Route = createFileRoute("/_authenticated/account/user/favorites")({
  beforeLoad: () => {
    throw redirect({ to: "/account/user/collections", search: { tab: "favorites" } });
  },
});
